import React, { useEffect, useState } from 'react';
import AddNewRole from 'src/components/Roles/AddNewRole';
import HeaderContentBlock from 'src/components/Common/HeaderContentBlock';
import { DataTable } from 'primereact/datatable';
import { Column } from 'primereact/column';
import { Paginator } from 'primereact/paginator';
import { roleList } from 'src/services/roles';
import ResponsiveRoleListAccordion from 'src/components/Responsive/roles/ResponsivRoleListAccordion';
import { dateTimeFormate } from 'src/utils/function';
import ResponsiveHeaderContentBlock from 'src/components/Responsive/ResponsiveHeaderContentBlock';

const Roles = () => {
    const [addNewRole, setAddNewRole] = useState(false);
    const [isSave, setIsSave] = useState(false);
    const [btnDisabled, setBtnDisabled] = useState(false);
    const [searchInput, setSearchInput] = useState('');
    const [page, setPage] = useState(0);
    const [rows, setRows] = useState(50);
    const [first, setFirst] = useState(0);
    const [roleListData, setRoleListData] = useState([]);
    const [totalRoleRecords, setTotalRoleRecords] = useState(0);
    const [openAcoordionResponsive, setOpenAcoordionResponsive] = useState<any>(null);
    const [isLoading, setIsLoading] = useState(false);
    const [isUpdate, setIsUpdate] = useState(false);
    const [selectedRowData, setSelectedRowData] = useState<any>(null);

    const controller = new AbortController();

    useEffect(() => {
        if (searchInput) {
            getRoleList(`?page=${page}&limit=${rows}&search=${searchInput}`, controller.signal);
        } else {
            getRoleList(`?page=${page}&limit=${rows}`, controller.signal);
        }
        return () => controller.abort();
    }, [page, rows, searchInput]);

    const getRoleList = async (url: string, signal?: any) => {
        try {
            setIsLoading(true);
            const roleResData = await roleList(url, signal);
            const data = roleResData?.data?.data;
            setRoleListData(data.roles);
            setTotalRoleRecords(data.total);
            setIsLoading(false);
        } catch (error) {
            setIsLoading(false);
        }
    };
    const handleRowClick = (row: any) => {
        setIsUpdate(true);
        setAddNewRole(true);
        setSelectedRowData(row.data);
    };

    const handleSearch = (e: any) => {
        setPage(0);
        setSearchInput(e.target.value);
    };
    const newRoleSuccess = () => {
        if (page === 0) {
            getRoleList(`?page=${page}&limit=${rows}`, controller.signal);
        } else {
            setPage(0);
            setFirst(0);
        }
        setAddNewRole(false);
        setBtnDisabled(false);
        setIsUpdate(false);
        setSelectedRowData(null);
    };
    const onPageChange = (event: any) => {
        setFirst(event.first);
        setRows(event.rows);
        setPage(event.page);
    };

    const GetName = (row: any) => <div>{row?.name}</div>;
    const GetDescription = (row: any) => <div>{row?.description || row?.description !== '' ? row?.description : '-'}</div>;
    const GetDisplayName = (row: any) => <div>{row?.display_name}</div>;
    const GetRoleCreated = (row: any) => <div>{row.created_at ? dateTimeFormate(row.created_at, 'DD MMM, YYYY') : '-'}</div>;

    return (
        <div>
            <div>
                <ResponsiveHeaderContentBlock
                    sortOnClick={() => {}}
                    closeOnClick={() => {
                        setAddNewRole(false);
                        setSelectedRowData(null);
                        setIsUpdate(false);
                    }}
                    addNewOnClick={() => setAddNewRole(true)}
                    isDisabled={addNewRole}
                    searchOnchange={handleSearch}
                    searchInput={searchInput}
                    isNext={addNewRole}
                />
            </div>
            <HeaderContentBlock
                closeOnClick={() => {
                    setAddNewRole(false);
                    setSelectedRowData(null);
                    setIsUpdate(false);
                }}
                saveOnClick={() => setIsSave(true)}
                addNewOnClick={() => setAddNewRole(true)}
                nextStep={addNewRole}
                addNewBtnText={'Add new Role'}
                isEmploy={true}
                headerText="Roles"
                isDisabled={btnDisabled}
                searchOnchange={handleSearch}
                searchInput={searchInput}
                // sortOnClick={() => {}}
            />
            {addNewRole && (
                <AddNewRole
                    setIsSave={setIsSave}
                    isSave={isSave}
                    isOnSuccess={() => {
                        newRoleSuccess();
                    }}
                    setBtnDisabled={setBtnDisabled}
                    btnDisabled={btnDisabled}
                    isUpdate={isUpdate}
                    selectedRowData={selectedRowData}
                />
            )}
            <div className={`pt-5 pb-0 w-full ${addNewRole ? 'hidden' : 'max-lg:block hidden'}`}>
                <>
                    {roleListData?.length === 0 && (
                        <div
                            className=" bg-white max-md:h-10 flex justify-center items-center max-lg:font-semibold
                         max-lg:text-xl max-lg:h-12  max-md:font-medium max-md:text-lg"
                        >
                            No Role Found
                        </div>
                    )}
                    <ResponsiveRoleListAccordion
                        roleListData={roleListData}
                        openAcoordionResponsive={openAcoordionResponsive}
                        setOpenAcoordionResponsive={setOpenAcoordionResponsive}
                        onRowClick={handleRowClick}
                    />
                    <div className="mt-5">
                        <Paginator
                            first={first}
                            rows={rows}
                            totalRecords={totalRoleRecords}
                            onPageChange={onPageChange}
                            className="datatable_pagination"
                            template="FirstPageLink PrevPageLink CurrentPageReport NextPageLink LastPageLink"
                        />
                    </div>
                </>
            </div>
            <div className="py-6 hidden lg:block">
                <DataTable value={roleListData} tableClassName="logdatatable" emptyMessage="No Role Found" className="" loading={isLoading} onRowClick={handleRowClick}>
                    <Column field="name" header="Name" body={GetName}></Column>
                    <Column field="display_name" header="Display Name" body={GetDisplayName}></Column>
                    <Column field="description" header="Description" body={GetDescription}></Column>
                    <Column field="created_at" header="Created Date" body={GetRoleCreated}></Column>
                </DataTable>
                <Paginator
                    first={first}
                    rows={rows}
                    totalRecords={totalRoleRecords}
                    onPageChange={onPageChange}
                    className="datatable_pagination"
                    template="FirstPageLink PrevPageLink CurrentPageReport NextPageLink LastPageLink"
                />
            </div>
        </div>
    );
};

export default Roles;
